import { cn } from "@repo/lib";
import type { HTMLAttributes, JSX } from "react";

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export const Skeleton = ({ className, ...props }: SkeletonProps): JSX.Element => {
  return (
    <div
      {...props}
      className={cn("animate-pulse bg-neutral-200 shadow-none", className)}
    />
  );
};
